/**
 * M64 Social Share
 * Handles social sharing functionality
 */

const M64SocialShare = {
  elements: {
    shareButtons: null
  },
  
  init() {
    this.elements.shareButtons = document.querySelectorAll('.m64-social-share__share-btn');
    this.bindEvents();
  },
  
  bindEvents() {
    this.elements.shareButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const platform = button.dataset.platform;
        this.share(platform);
      });
    });
  },
  
  share(platform) {
    const url = window.location.href;
    let shareUrl = '';
    
    switch(platform) {
      case 'x':
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        break;
      case 'bluesky':
        shareUrl = `https://bsky.app/intent/compose?text=${encodeURIComponent(url)}`;
        break;
      case 'whatsapp':
        shareUrl = `https://wa.me/?text=${encodeURIComponent(url)}`;
        break;
      case 'email':
        shareUrl = `mailto:?body=${encodeURIComponent(url)}`;
        break;
    }
    
    if (shareUrl) {
      if (platform === 'email') {
        window.location.href = shareUrl;
      } else {
        window.open(shareUrl, '_blank', 'width=600,height=400');
      }
    }
  }
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => M64SocialShare.init());
} else {
  M64SocialShare.init();
}

// Expose for debugging
window.M64SocialShare = M64SocialShare;